<script setup>
import AppHeader from '../components/layout/AppHeader.vue'
import MobileDrawer from '../components/layout/MobileDrawer.vue'
import { useGlobalStore } from '../composables/useGlobalStore'
import AppFooter from 'components/layout/AppFooter'
import AuthModal from 'components/auth/AuthModal'
import CookieConsent from 'components/general/CookieConsent'
import { computed, onMounted, provide, reactive, ref, watch } from 'vue'
import InvalidPotentialPopup from '#/analyzer/InvalidPotentialPopup'
import { apolloClient } from 'boot/apollo'
import { useAnalyzer } from '#/analyzer/useAnalyzer'
import debounce from 'debounce'
import AppLoader from '#/general/AppLoader'
import { useRoute } from 'vue-router'
import { useB2CAnalyzer } from 'src/composables/useB2CAnalyzer'
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import { ruleHub } from 'vue3-form'
import PhoneNumber from 'awesome-phonenumber'

ruleHub.required.message = () => 'Dieses Feld ist ein Pflichtfeld!'
ruleHub.firstName = {
  test: ({ value }) => value ? value.length >= 2 : false,
  message: () => 'Geben Sie bitte Ihren Vornamen ein'
}
ruleHub.lastName = {
  test: ({ value }) => value ? value.length >= 2 : false,
  message: () => 'Geben Sie bitte Ihren Namen ein'
}
// Dieses Feld muss mindestens zwei Buchstaben enthalten.
ruleHub.required.test = (val) => {
  let correct = ![null, undefined, ''].includes(val)
  if (typeof val.value === 'string' || Array.isArray(val.value)) {
    correct = val.value.length > 0
  }
  return correct
}

ruleHub.email.message = () => 'Bitte gültige E-Mail-Adresse eingeben.'

ruleHub.phoneNumber = {
  message: () => 'Bitte gültige Telefonnummer eingeben. +41 71 521 21 26',
  test: (val) => {
    if (val.value) {
      const pn = new PhoneNumber(val.value)
      return pn.isValid()
    }
    return true
  }
}

const { handleTrackingLink, authUserFromTokens, isBrowser, isLoggedIn, userDetailsLoaded, authModalVisible, isProduction, authModalTab, loadGlobalConfig } = useGlobalStore()
const route = useRoute()
const { sharedApolloClient, analyzerType, showInvalidPotentialPopup } = useAnalyzer()
const { version } = useDetailsReport()
const { form } = useB2CAnalyzer()
sharedApolloClient.value = apolloClient

await loadGlobalConfig()
if (isBrowser) {
  await authUserFromTokens()
}

const screen = reactive({
  width: 375,
  height: 667,
  gt: {
    xs: true,
    sm: false,
    md: false,
    lg: false,
    xl: false
  },
  lt: {
    xs: false,
    sm: true,
    md: true,
    lg: true,
    xl: true
  }
}
)

let loadScreen = () => {
  const width = document.documentElement.clientWidth
  const height = document.documentElement.clientHeight
  screen.width = width
  screen.height = height
  screen.gt = {
    xs: width >= 600,
    sm: width >= 1024,
    md: width >= 1439,
    lg: width >= 1440,
    xl: width >= 1920
  }
  screen.lt = {
    xs: width < 600,
    sm: width < 1024,
    md: width < 1439,
    lg: width < 1440,
    xl: width < 1920
  }
}
onMounted(() => {
  window.addEventListener('resize', function () {
    loadScreen()
  })
  loadScreen()
  loadScreen = debounce(loadScreen, 1000)
  handleTrackingLink(route.query)
})

const global = computed(() => {
  if ((analyzerType.value === 'B2C' || version.value === 2)) {
    return {
      graphicElementColor: '#1F47CD',
      buttonBackground: '#1F47CD',
      buttonBackgroundHover: '#007BFF',
      buttonColor: '#ffffff',
      buttonBorderRadius: '10px',
      renovationPressureLabel: 'Sanierungsdruck',
      potentialVolumeLabel: 'Entwicklungspotenzial',
      potentialVolumeTooltipBody: '<div>Erstabschätzung der ungenutzten Geschossflächen durch den<a class="q-mx-xs" target="_blank" href="http://www.raumpioniere.ch/">Raumpioniere</a> Algorithmus, auf Basis öffentlich-rechtlicher Daten mit unter<a class="q-mx-xs" target="_blank" href="https://www.housing-stat.ch/de/start.html">Gebäude- und Wohnungsregister</a> (GWR),<a class="q-mx-xs" target="_blank" href="https://www.swisstopo.admin.ch/de/home.html">Swisstopo</a> und<a class="q-mx-xs" target="_blank" href="https://www.swissenergyplanning.ch/">Swiss Energy Planning</a> (SEP) by<a class="q-mx-xs" target="_blank" href="https://www.geoimpact.ch/">geoimpact AG.</a></div>',
      mapbox: {
        outlineColor: '#5FEFC0',
        outlineLineWidth: 2,
        fillColor: 'rgba(95, 239, 192, 0.4)',
        fillOpacity: 0.5
      }
    }
  }
  return {
    graphicElementColor: '#1F47CD',
    buttonBackground: '#1F47CD',
    buttonBackgroundHover: '#007BFF',
    buttonColor: '#ffffff',
    buttonBorderRadius: '10px',
    renovationPressureLabel: 'Optimierungsdruck',
    potentialVolumeLabel: 'Verdichtungspotenzial',
    potentialVolumeScoreLabel: 'verdichtungs-score',
    potentialVolumeTooltipBody: '<div>Erstabschätzung der ungenutzten Geschossflächen durch den<a class="q-mx-xs" target="_blank" href="http://www.raumpioniere.ch/">Raumpioniere</a> Algorithmus, auf Basis öffentlich-rechtlicher Daten mit unter<a class="q-mx-xs" target="_blank" href="https://www.housing-stat.ch/de/start.html">Gebäude- und Wohnungsregister</a> (GWR),<a class="q-mx-xs" target="_blank" href="https://www.swisstopo.admin.ch/de/home.html">Swisstopo</a> und<a class="q-mx-xs" target="_blank" href="https://www.swissenergyplanning.ch/">Swiss Energy Planning</a> (SEP) by<a class="q-mx-xs" target="_blank" href="https://www.geoimpact.ch/">geoimpact AG.</a></div>',
    mapbox: {
      outlineColor: '#5FEFC0',
      outlineLineWidth: 2,
      fillColor: 'rgba(95, 239, 192, 0.4)',
      fillOpacity: 0.5
    }
  }
})

const components = computed(() => {
  return {
    searchBox: {
      resultsBackgroundColor: 'white',
      resultsColor: 'black',
      input: {
        text: 'Adresse eingeben und loslegen',
        textMobile: 'Adresse eingeben und loslegen',
        background: '#ffffff',
        color: '#B4BCCE',
        fontSize: '18px',
        fontSizeMobile: '18px',
        fontWeight: '500',
        fontWeightMobile: '500'
      },
      button: {
        text: 'Jetzt Analyse starten',
        textMobile: 'Jetzt Analyse starten',
        background: '#1F47CD',
        color: '#ffffff',
        fontSize: '20px',
        fontSizeMobile: '16px',
        fontWeight: '600',
        fontWeightMobile: '600'
      }
    },
    fullPopup: ((analyzerType.value === 'B2C' && !showInvalidPotentialPopup.value) || version.value === 2) ? {
      backgroundColor: 'linear-gradient(152.99deg, #2F3849 78.27%, #21252E 157.29%)',
      containerMaxWidth: '563px',
      containerPadding: '33px',
      containerPaddingMobile: '20px',
      containerMargin: '0 0 0 0',
      containerMarginMobile: '30px 0px 30px 0px',
      title: {
        color: 'white',
        fontSize: '24px',
        fontWeight: '700',
        fontSizeMobile: '20px',
        fontWeightMobile: '700'
      },
      submitBtn: {
        background: '#5FEFC0',
        color: '#22223C',
        fontSize: '20px',
        fontSizeMobile: '16px',
        fontWeight: '600',
        fontWeightMobile: '500'
      }
    } : {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      containerMaxWidth: '827px',
      containerPadding: '30px',
      containerPaddingMobile: '50px 20px',
      containerMargin: '0 0 0 0',
      containerMarginMobile: '200px 0px 30px 0px',
      title: {
        color: '#1F47CD',
        fontSize: '24px',
        fontWeight: '700',
        fontSizeMobile: '24px',
        fontWeightMobile: '700'
      },
      submitBtn: {
        background: '#5FEFC0',
        color: '#22223C',
        fontSize: '20px',
        fontSizeMobile: '20px',
        fontWeight: '600',
        fontWeightMobile: '600'
      }
    }
  }
})

const CTA_SECTION_CONFIG_V1 = {
  sectionTitle: 'Unsere qualifizierten Ansprechpartner:',
  backgroundColor: '#2F3849',
  headerTitle: {
    color: '#ffffff',
    fontSize: '16px',
    fontSizeMobile: '16px',
    fontWeight: '600',
    fontWeightMobile: '600'
  },
  name: {
    color: '#5FEFC0',
    fontSize: '20px',
    fontSizeMobile: '20px',
    fontWeight: '800',
    fontWeightMobile: '800'
  },
  infoText: {
    color: '#ffffff',
    fontSize: '20px',
    fontSizeMobile: '20px',
    fontWeight: '500',
    fontWeightMobile: '500'
  },
  button: {
    background: '#5FEFC0',
    color: '#22223C',
    fontSize: '20px',
    fontSizeMobile: '20px',
    fontWeight: '600',
    fontWeightMobile: '600'
  }
}

const CTA_SECTION_CONFIG_V2 = {
  sectionTitle: 'Unsere qualifizierten Ansprechpartner:',
  backgroundColor: '#2F3849',
  headerTitle: {
    color: '#626C85',
    fontSize: '18px',
    fontSizeMobile: '14px',
    fontWeight: '500',
    fontWeightMobile: '500'
  },
  name: {
    color: '#1F47CD',
    fontSize: '20px',
    fontSizeMobile: '14px',
    fontWeight: '700',
    fontWeightMobile: '700'
  },
  infoText: {
    color: '#22223',
    fontSize: '20px',
    fontSizeMobile: '14px',
    fontWeight: '500',
    fontWeightMobile: '500'
  },
  button: {
    background: '#1F47CD',
    color: 'white',
    fontSize: '18px',
    fontSizeMobile: '12x',
    fontWeight: '600',
    fontWeightMobile: '600'
  }
}

const pages = ref({
  landing: {
    img: 'widgetImg1.jpeg',
    imgMobile: 'widgetImg1.jpeg',
    title: {
      text: 'Kennen Sie das Entwicklungspotenzial Ihrer Liegenschaft?',
      textMobile: 'Kennen Sie das Entwicklungspotenzial Ihrer Liegenschaft?',
      color: '#F6F7FA',
      fontSize: '60px',
      fontSizeMobile: '24px',
      fontWeight: '700',
      fontWeightMobile: '800'
    },
    subtitle: {
      text: 'Starten Sie jetzt mit der Ermittlung des Verdichtungspotenzials Ihrer (Wunsch)Immobilie – und gehen Sie dann von da aus mit uns weiter.',
      textMobile: 'Starten Sie jetzt mit der Ermittlung des Verdichtungspotenzials Ihrer (Wunsch)Immobilie – und gehen Sie dann von da aus mit uns weiter.',
      color: '#F6F7FA',
      fontSize: '20px',
      fontSizeMobile: '16px',
      fontWeight: '400',
      fontWeightMobile: '400'
    }
  },
  map: {
    quickView: {
      dataDisabledText: 'Registriere dich jetzt kostenlos, um den vollen Zugriff auf die Analyseergebnisse zu erhalten.',
      potentialVolumeLowColor: '#007BFF',
      potentialVolumeMediumColor: '#007BFF',
      potentialVolumeHighColor: '#FFF',
      potentialVolumeLowBackground: '#EB604F',
      potentialVolumeMediumBackground: '#F6D156',
      potentialVolumeHighBackground: '#5FEFC0',
      renovationPressureLowColor: '#007BFF',
      renovationPressureMediumOneColor: '#007BFF',
      renovationPressureHighColor: '#FFF',
      renovationPressureLowBackground: '#DCE7F2',
      renovationPressureMediumOneBackground: '#F6D156',
      renovationPressureHighBackground: '#EB604F'
    },
    invalidPotentialPopup: {
      title: 'Hinweis: Spezielle Gebäudeklasse.',
      body: '<div style="font-weight: 400; font-size: 16px; line-height: 170%; letter-spacing: 0.03em;color: #464D5F; margin: 20px 0">Für die #{invalidPotentialBuildingCategory} bieten wir heute noch keine konventionelle automatisierte Potenzialanalyse an. Haben Sie trotzdem Fragen zum Verdichtungspotenzial der #{searchText}? Nehmen Sie Kontakt mit uns auf.</div>',
      btn: 'Andere Adresse analysieren'
    },
    dataSetIncompletePopup: {
      title: 'Hinweis: Datensatz unvollständig.',
      body: 'Um für diese Adresse eine komplette Potenzialanalyse durchführen zu können, fehlen uns leider einige Daten. Entsprechend können einzelne Angaben oder Resultate fehlen – wir bitten Sie dafür um Verständnis.',
      btn: 'Alles klar'
    },
    maxNumberOfReportsReachedPopup: {
      title: 'Hinweis: Maximum Adressabfragen erreicht.',
      body: `
        <div>Um unser Produkt vor unsachgemässem Gebrauch zu schützen, ist es aktuell nur möglich, <strong>maximal drei Adressabfragen</strong> durchzuführen.</div>
        <div style="margin-top: 20px">Möchtest du trotzdem mehr als die drei möglichen Abfragen durchführen, nimm doch bitte mit unserem Sales-Team Kontakt auf.</div>
              `,
      btn: 'Sales-Team kontaktieren'
    },
    mailNotificationPopup: {
      title: 'Der Link zu Ihrem Report wurde soeben versandt.',
      body: `
                <div>Eben haben wir Ihnen per E-Mail einen Link zu Ihrem Report geschickt. Schauen Sie in Ihrem Postfach nach, um den Detailreport zu Ihrer Liegenschaft einzusehen.</div>
                <div style="margin-top: 15px">Hinweis: Um unser Produkt zu schützen, sind aktuell nur maximal drei Adressabfragen pro NutzerIn möglich.</div>
              `,
      btn: 'Alles klar'
    },
    list: {
      missingPotentialImg: 'missingHouse.png',
      missingPotentialImgMobile: 'missingHouseMobile.png'
    }
  },
  detailReport: {
    addressColor: '#1F47CD',
    addressFontSize: '23px',
    showProjectPhases: true,
    showCheckListPanel: true,
    mapboxViewBtnSelectedColor: 'white',
    mapboxViewBtnSelectedBackgroundColor: 'black',
    mapboxViewBtnUnselectedColor: 'black',
    mapboxViewBtnUnselectedBackgroundColor: 'white',
    firstSteps: {
      title: {
        text: 'Potenzial vorhanden? Deine nächsten Schritte:',
        textMobile: 'Potenzial vorhanden? Deine nächsten Schritte:',
        color: '#22223C',
        fontSize: '30px',
        fontSizeMobile: '20px',
        fontWeight: '700',
        fontWeightMobile: '700'
      },
      explanation: {
        firstText: 'Gerade zu Beginn einer Immobilienentwicklung ist es wichtig, dass Sie mit aller gebotenen Sorgfalt unterwegs sind und die richtigen Entscheidungen für Ihr Projekt treffen. Denn gerade in den frühen Phasen ist bei tiefen Kosten die Manövrierfähigkeit eines Projekts nämlich noch hoch,  weshalb es vernünftig ist, vor dem eigentlichen Projekt eine zuverlässige und saubere Entscheidungsgrundlage zu erarbeiten.',
        secondText: 'Wir unterstützen dich sehr gern dabei, dein Projekt bereits in den frühen Phasen einer Immobilienentwicklung auf den bestmöglichen Weg zu bringen.'
      },
      checklist: {
        title: 'Checkliste für den Start in eine Liegenschaftsentwicklung',
        subtitle: 'Mit der unten aufgeführten Checkliste für eine Immobilien- oder Liegenschaftsentwicklung können Sie Punkt für Punkt abhaken und ihrer Vision immer näherkommen. Von der  Abklärung der zivilrechtlichen Rahmenbedingungen über die Sicherstellung zur Finanzierung Kalkulation der Kosten bis hin zu den passenden Partnern für Ihr Projekt.',
        askMoreColor: '#007BFF',
        items: [
          {
            label: 'Abklärung der zivilrechtlichen Rahmenbedingungen',
            selected: true,
            notExpandedText: 'Ein Servitut ist eine Dienstbarkeit an einer fremden Sache, die entweder eine Duldung oder eine Unterlassung für andere begründet.',
            expandedText: 'Servitute oder auch Dienstbarkeiten sind für die Frage der Machbarkeit einer Immobilienentwicklung also zentral – klären Sie sie deshalb immer so früh wie möglich ab. Diese Art von zivilrechtlichen Verträgen ist in den Grundbüchern vermerkt. Entsprechend können Sie sie beim Grundbuchamt einsehen.'
          },
          {
            label: 'Terminplan und Zeitbedarf',
            selected: false,
            notExpandedText: 'Planen und Bauen benötigt immer viel Zeit – und zwar nicht nur für die Planer und Handwerker, sondern auch für die Bauherrschaft.',
            expandedText: 'Unterschätzen Sie also auf keinen Fall den Zeitbedarf für die Eigentümer – das kann in der wichtigen Planungs- und Bauphase unnötige Kosten verursachen.'
          },
          {
            label: 'Professioneller Check der Ausnützungsreserven',
            selected: false,
            notExpandedText: 'Mit einer Potenzialanalyse ist sicher mal ein erster Schritt getan. Bevor Sie nun aber mit der Planung beginnen, empfehlen wir Ihnen einen professionellen Check der Ausnützungsreserven.',
            expandedText: 'Eine fundierte Aussage zur Liegenschaft kann erst dann erfolgen, wenn sämtliche Faktoren – wie beispielsweise mögliche Servitute sowie Sonder- oder Quartierplanauflagen – in die Potenzialanalyse mit eingeflossen sind. Ist dies passiert, können Sie die nächsten Schritte hin zur Optimierung der Parzelle bzw. Liegenschaft auslösen.'
          },
          {
            label: 'Klärung der finanziellen Rahmenbedingungen',
            selected: false,
            notExpandedText: 'Bauen kostet Geld. Klären Sie die eigenen finanziellen Möglichkeiten bereits früh ab und checken Sie auch gleich all die verschiedenen Finanzierungsmöglichkeiten.',
            expandedText: 'Weil eine Immobilienentwicklung auch stets für Überraschungen sorgen kann, empfehlen wir Ihnen, immer entsprechende Reserven für Unvorhergesehenes einzuplanen. So stellen Sie sicher, dass die eigene Immobilienentwicklung nicht in einem finanziellen Desaster endet.'
          },
          {
            label: 'Gebäudecheck im Falle einer Sanierung/Erweiterung',
            selected: false,
            notExpandedText: 'Weiterbauen anstelle eines Ersatzneubaus macht in vielen Fällen Sinn und führt oftmals zur reichhaltigeren Lösung, als ein einfacher Ersatzneubau.',
            expandedText: 'Wer das Weiterbauen in Betracht zieht, sollte  den Bestandesbau jedoch frühzeitig von Fachspezialisten unter die Lupe nehmen. Dazu gehört eine Analyse bezüglich Gebäudehülle, Altlasten, Tragwerk, Brandschutz sowie der Haustechnik und Leitungsführung. Aber auch die baurechtliche Ausgangslage ist zu beachten. Nur wer frühzeitig den Bestand auf allen Ebenen durchleuchtet, vermeidet in späteren Phasen unangenehme und kostentreibende Überraschungen.'
          },
          {
            label: 'Klärung der eigenen Wohnbedürfnisse',
            selected: false,
            notExpandedText: 'Überlegen Sie sich bereits frühzeitig, wie sich Ihre eigenen Wohnbedürfnisse in den nächsten 30-50 Jahren entwickeln könnten und inwiefern Sie mit Ihrer Liegenschaft auf diese Veränderungen reagieren können.',
            expandedText: 'Denn „Wer baut, tut dies immer auch schon für die nächste Generation“ – so die Aussage eines bekannten Architekten.'
          },
          {
            label: 'Fördergelder und staatliche Unterstützung',
            selected: false,
            notExpandedText: 'Alle, die heutzutage bauen, sollten vorab die vielfältigen Möglichkeiten, in den Genuss staatlicher Unterstützung zu kommen, abklären.',
            expandedText: 'Fördergelder werden inzwischen in vielen Bereichen der nachhaltigen Bauweise, aber auch im Falle von historisch wertvollen Bauwerken (Denkmalschutz) gesprochen. Sie sorgen natürlich dafür, die Baukosten auf Seiten der Bauherrschaft tiefer zu halten.'
          },
          {
            label: 'Setze auf die richtigen Partner',
            selected: false,
            notExpandedText: 'Das richtige Team ist für die Entwicklung Ihrer Liegenschaft von zentraler Bedeutung.',
            expandedText: 'Es lohnt sich, die nötige Zeit in die Suche nach den bestmöglichen Projektbeteiligten zu suchen – schlussendlich wird Ihre Immobilienentwicklung nur so zu einem vollen Erfolg!'
          },
          {
            label: 'Abklärung der Marktlage (Mikro- und Makrolage)',
            selected: false,
            notExpandedText: 'Wer am Markt vorbeiplant, wird später Mühe bekunden, das eigene Angebot gewinnbringend zu vermieten oder auch zu veräussern.',
            expandedText: 'Bevor Sie also mit der Planung überhaupt erst starten, lohnt es sich, wenn Sie das gegebene Umfeld und die Marktlage genau unter die Lupe nehmen – und das eigene Angebot entsprechend auslegen. Selbst die schönste und beste 2-Zimmer-Wohnung bringt Ihnen nichts, wenn an ihrer Lage ausschliesslich Familien ein Zuhause suchen.'
          }
        ]
      }
    },
    potentialAnalysis: {
      progressLineFontColorLow: 'white',
      progressLineFontColorMedium: 'white',
      progressLineFontColorHigh: '#2E8BDF',
      progressLineBackgroundLow: '#EA604F',
      progressLineBackgroundMedium: '#F6D055',
      progressLineBackgroundHigh: '#5FEFC0',
      progressLineBoxSubtitle: 'Der Verdichtungs-Score bewertet die Liegenschaft auf Basis des Verdichtungspotenzials, der Parzellengrösse, der ÖV-Güteklasse sowie des Optimierungsdrucks. Je höher, umso stärker drängt sich eine Optimierung der entsprechenden Liegenschaft auf. Zudem ermöglicht der Verdichtungs-Score das einfache Vergleichen von Liegenschaften.',

      renovationPressureFontColorLow: '#2E8BDF',
      renovationPressureFontColorMedium: '#2E8BDF',
      renovationPressureFontColorHigh: 'white',
      renovationPressureBackgroundLow: '#5FEFC0',
      renovationPressureBackgroundMedium: '#F6D156',
      renovationPressureBackgroundHigh: '#EB604F',
      renovationPressureBoxSubtitle: 'Der Optmierungsdruck ermittelt auf Basis des Gebäudezustands sowie der Sanierungsdynamik im näheren Umfeld die Notwendigkeit einer einer Optimierung oder Sanierung der Liegenschaft. Er basiert auf öffentlich-rechtlichen Daten mit unter Gebäude- und Wohnungsregister (GWR), Swisstopo und Swiss Energy Planning (SEP) bygeoimpact AG.',

      overUsedText: 'kein Potenzial',
      overUsedTextMobile: 'kein Potenzial',
      overUsedBackground: '#EB604F',
      overUsedColor: '#FFFFFF'
    },
    ctaSection: CTA_SECTION_CONFIG_V1
  }
})

pages.value.detailReport.ctaSection = (version.value === 2 ? CTA_SECTION_CONFIG_V2 : CTA_SECTION_CONFIG_V1)
watch(version, v => {
  pages.value.detailReport.ctaSection = (version.value === 2 ? CTA_SECTION_CONFIG_V2 : CTA_SECTION_CONFIG_V1)
})

provide('Shared', {
  isLoggedIn,
  userDetailsLoaded,
  authModalTab,
  authModalVisible,
  isBrowser,
  isProduction,
  screen,
  application: 'WEB_APP',
  showB2CQuestionnairePopup: ref(false),
  global,
  components,
  pages
})
</script>

<template lang='pug'>
q-layout#layout(view="hHh lpR lff")
  app-loader
  app-header
  auth-modal
  mobile-drawer.lt-md
  cookie-consent
  invalid-potential-popup
  router-view
  app-footer(v-if="!['B2B Analyzer', 'B2C Analyzer'].includes($route.name)")
</template>

<style lang="sass">
.v-toast
  z-index: 10000 !important
.hoverableBox
  transition: box-shadow 0.2s ease-in-out
  &:hover
    box-shadow: 0px 5px 20px 0px rgb(0 0 0 / 20%)
body
  font-family: 'Montserrat', sans-serif !important
.q-dialog__backdrop
  background: rgba(208, 208, 208, 0.8) !important
  backdrop-filter: blur(10px) !important
  -webkit-backdrop-filter: blur(10px)
  @media screen and (min-width: 1024px)
    top: 90px !important
  @media screen and (max-width: 1023px)
    top: 80px !important
.routerPageSize
  margin: auto
  max-width: 100%
  @media screen and (min-width: 1250px)
    width: 1260px
  @media screen and (min-width: 600px) and (max-width: 1250px)
    max-width: 100% !important
    width: 100%
  @media screen and (max-width: 1250px)
    padding: 25px 15px
  @media screen and (max-width: 600px)
    width: 100%
    padding: 25px 15px
@keyframes rotation
  from
    transform: rotate(0deg)
  to
    transform: rotate(359deg)
.text-brandGreen
  color: #5FEFC0
.bg-brandGreen
  background-color: #5FEFC0

.text-brandDarkBlue
  color: #1F47CD
.text-brandBlue
  color: rgba(157, 157, 212, 1)
.bg-brandBlue
  background-color: rgba(157, 157, 212, 1)

.marker
  background: rgba(94, 242, 193, 0.5)
  background-size: cover
  width: 70px
  height: 70px
  border-radius: 50%
  display: flex
  justify-content: center
  align-items: center
  @media screen and (max-width: 1024px)
    height: 40px !important
    width: 40px !important
  .markerInner
    background: #5EF2C1
    width: 25px
    height: 25px
    border-radius: 100%
    position: relative
    @media screen and (max-width: 1024px)
      height: 15px !important
      width: 15px !important
</style>
